<template>
    <span 
        class='my-toggle'  
        :class="{'item-checked': value === true}"
        @change="handleClick"
    >
        <label :for="name" class='my-toggle-label' />
        <input type='checkbox' :checked="value === true" :id="name"/>
    </span>
</template>

<script>
export default {
    name: 'toggle',
    props: ['value', 'name', 'onChange'],
    methods: {
        handleClick () {
            this.onChange && this.onChange(this.name, !this.value)
        }
    }
}
</script>

<style lang='scss' scoped>
$item-width: 60px;
$item-height: 30px;
$red: rgb(201, 116, 116);
$green: rgb(119, 156, 119);
.my-toggle {
    cursor: pointer;
    border: 1px solid $red;
    background-color: $red;
    position: relative;
    width: $item-width;
    height: $item-height;
    border-radius: calc(#{$item-height} - 10px);
    transition: all .3s;
    display: block;
    input[type=checkbox] {
        display: none;
    }
    .my-toggle-label {
        cursor: pointer;
        height: 100%;
        width: 100%;
        margin: 0;
        display: block;
        position: relative;
        &::after {
            position: absolute;
            top: 0;
            left: 0;
            height: $item-height;
            width: $item-height;
            content: '';
            background-color: #fff;
            border-radius: 50%;
        }
    }
    &.item-checked {
        background-color: $green;
        border: 1px solid $green;
        label::after {
            left: auto;
            right: 0;
        }
    }
}
</style>